<script setup lang="ts">
import IonicModal from '~/components/Common/Modal/ionic-modal.vue'
import WebModal from '~/components/Common/Modal/web-modal.vue'

defineProps<{
	show: boolean
	title: string
	boxClass?: string
}>()

const emits = defineEmits(['close'])

</script>

<template>
	<component
		:is="useRenderingMode().isMobileApp ? IonicModal : WebModal"
		:show="show"
		:title="title"
		:boxClass="boxClass"
		@close="emits('close')">
		<slot />
	</component>
</template>

